module.exports = __webpack_public_path__ + "static/img/16.2a8ac9f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/trainPlan/10sportDesc/16.svg
// module id = mTXi
// module chunks = 0